<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-09-12 14:46:07
 * @LastEditors: DESKTOP-ROEB53E\caiyangjie 1760178806@qq.com
 * @LastEditTime: 2024-02-26 10:31:40
 * @FilePath: \合联\oms\src\view\finances\segmentDetails\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <Card class="tabs">
    <Tabs type="card" name="S" v-model="tabName" @on-click="handleTab">
      <TabPane
        v-for="(item, idx) in tabList"
        tab="S"
        :key="idx"
        :label="item.label"
        :name="item.value"
        style="height: 100%"
      >
        <Tax
          :ref="item.value"
          v-if="item.value === 'S_TAX'"
          :tabName="item.value"
        />
        <Bill
          type="tm"
          :ref="item.value"
          v-else-if="item.value === 'S_BILL'"
          :tabName="item.value"
        />
        <Clearance
          type="clearance"
          :ref="item.value"
          v-else-if="item.value === 'S_Clearance'"
          :tabName="item.value"
        />
        <cTable v-else :ref="item.value" :tabName="item.value" />
      </TabPane>
    </Tabs>
  </Card>
</template>

<script>
import cTable from "./table";
import Tax from "./tax";
import Bill from "./bill";
import Clearance from "./clearance";
export default {
  name: "segmentDetails",
  components: {
    cTable,
    Tax,
    Bill,
    Clearance
  },
  mounted() {
    this.handleTab(this.tabName);
  },
  methods: {
    handleTab(e) {
      console.log(this.$refs);
      if (!this.$refs[e][0].init) {
        this.$refs[e][0].init = true;
        this.$refs[e][0].$refs.table.getList();
      }
    }
  },
  data() {
    return {
      tabList: [
        {
          label: this.$tz("头程"),
          value: "S_BEG"
        },
        {
          label: this.$tz("尾程"),
          value: "S_END"
        },
        {
          label: this.$tz("税"),
          value: "S_TAX"
        },
        {
          label: this.$tz("清派提单"),
          value: "S_BILL"
        },
        {
          label: this.$tz("清关,税费,结算"),
          value: "S_Clearance"
        }
        // {
        //   label: this.$tz("汇总"),
        //   value: "S_ALL"
        // }
      ],
      tabName: "S_BEG"
    };
  }
};
</script>

<style>
.tabs .ivu-tabs-content {
  height: calc(100% - 30px);
}
.tabs,
.tabs .ivu-card-body,
.tabs .ivu-tabs {
  height: 100%;
}
</style>
